module.exports = __webpack_public_path__ + "media/images/home/document-b86b75742a1ff509210a623806e3806b.png";